import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowLeft } from 'lucide-react';

const Phoenix = () => {
  const navigate = useNavigate();

  // Prüfen ob der Benutzer authentifiziert ist
  useEffect(() => {
    const isAuthenticated = sessionStorage.getItem('portfolioAuth');
    if (!isAuthenticated) {
      // Zurück zur Startseite, wenn nicht authentifiziert
      navigate('/');
    }
  }, [navigate]);

  return (
    <div className="min-h-screen bg-white">
      {/* Decorative Background Elements */}
      <div className="fixed inset-0 -z-10 overflow-hidden pointer-events-none">
        <div className="absolute top-20 right-10 w-96 h-96 bg-amber-500/5 rounded-full blur-3xl animate-float"></div>
        <div className="absolute bottom-20 left-10 w-80 h-80 bg-orange-500/5 rounded-full blur-3xl animate-float-delayed"></div>
      </div>

      {/* Header mit Zurück-Button */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b border-gray-200">
        <div className="container mx-auto px-6 py-4">
          <Button
            onClick={() => navigate('/portfolio')}
            variant="ghost"
            className="text-primary-dark hover:text-amber-600"
          >
            <ArrowLeft className="w-5 h-5 mr-2" />
            Zurück zum Portfolio
          </Button>
        </div>
      </header>

      {/* Überschrift Section mit weißem Hintergrund */}
      <section className="pt-32 pb-12 px-6 bg-white">
        <div className="container mx-auto max-w-6xl text-center">
          <h1 className="text-4xl sm:text-5xl font-bold mb-4" style={{ color: '#B8860B' }}>
            Phoenix
          </h1>
          <p className="text-xl sm:text-2xl text-gray-700 mb-8 font-medium">
            Brand Transformation | Strategy | Visual Identity
          </p>
          <Button
            size="lg"
            className="text-white font-semibold px-8 py-3 text-lg shadow-xl hover:shadow-2xl transition-all duration-300"
            style={{ backgroundColor: '#B8860B' }}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#8B6914'}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#B8860B'}
          >
            Zu Phoenix
          </Button>
        </div>
      </section>

      {/* Content Section mit Text */}
      <section className="py-20 px-6 bg-gray-50">
        <div className="container mx-auto max-w-5xl">
          {/* Hauptüberschrift */}
          <div className="mb-12">
            <h2 className="text-3xl font-bold mb-6" style={{ color: '#B8860B' }}>
              Phoenix – Brand & Community Concept
            </h2>

            <div className="space-y-6 text-lg text-gray-700 leading-relaxed">
              <p>
                Phoenix ist ein innovatives Community- und Servicekonzept für Menschen in persönlichen oder beruflichen Umbruchphasen. Die Marke basiert auf der Idee, Krisen nicht als Endpunkt, sondern als Ausgangspunkt für Entwicklung und Neuausrichtung zu verstehen.
              </p>
              <p>
                Im Zentrum steht ein interdisziplinäres Netzwerk aus Psychologen, Juristen, Wellness-Experten und Image-Beratern, das Betroffene professionell begleitet. Ergänzt wird das Angebot durch Expertenseminare, digitale Austauschformate und moderierte Community-Gruppen, in denen Teilnehmer Erfahrungen teilen und neue Perspektiven entwickeln können.
              </p>
              <p>
                Das Brand Growing konzentriert sich auf den Aufbau einer vertrauensvollen Community, die Vermittlung von Expertenwissen sowie die langfristige Begleitung von Menschen auf ihrem Weg zum persönlichen „Reborn". Phoenix positioniert sich dabei als Plattform für Transformation, Resilienz und nachhaltige persönliche Entwicklung.
              </p>
            </div>
          </div>

          {/* Phoenix Bilder */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <img
              src="https://customer-assets.emergentagent.com/job_ki-governance-legal/artifacts/goh5mrtl_Bildschirmfoto%202026-06-18%20um%2016.30.26.png"
              alt="Phoenix Brand Concept - Aus der Asche neu geboren"
              className="w-full h-auto rounded-xl shadow-lg"
            />
            <img
              src="https://customer-assets.emergentagent.com/job_ki-governance-legal/artifacts/qp33tzcr_Bildschirmfoto%202026-06-18%20um%2016.30.42.png"
              alt="Phoenix Brand - Vier Schritte zu Ihrem Neuanfang"
              className="w-full h-auto rounded-xl shadow-lg"
            />
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-20 px-6 bg-gradient-to-br from-amber-600 to-orange-800">
        <div className="container mx-auto max-w-4xl text-center">
          <h2 className="text-3xl font-bold text-white mb-6">
            Mehr Projekte entdecken?
          </h2>
          <p className="text-xl text-white/90 mb-8">
            Entdecken Sie weitere spannende Projekte aus meinem Portfolio.
          </p>
          <Button
            onClick={() => navigate('/portfolio')}
            size="lg"
            className="bg-white hover:bg-gray-100 font-semibold px-8 py-3 text-lg"
            style={{ color: '#B8860B' }}
          >
            Zurück zum Portfolio
          </Button>
        </div>
      </section>
    </div>
  );
};

export default Phoenix;
